function Hero() {
    return (
      <section className="hero">
        <h1>Transform Your Body</h1>
        <p>Best Gym Training in Your City</p>
        <button onClick={() => {
          document.getElementById("contact").scrollIntoView({ behavior: "smooth" });
        }}>
          Join Now
        </button>
      </section>
    );
  }
  
  export default Hero;